<template>
  <footer class="site-footer" dir="rtl">
    <a v-if="data.whatsapp_number" class="whatsapp-float" target="_blank" rel="noopener"
      :href="`https://wa.me/${String(data.whatsapp_number).replaceAll(' ', '')}`" aria-label="واتساب">
      <img src="../../assets/images/WhatsApp.svg.webp" alt="تواصل معنا عبر واتساب">
    </a>

    <div class="footer-main">
      <div class="footer-brand">
        <img class="footer-logo" src="../../assets/images/logo-word.png" alt="منصة البارون">
        <div>
          <div class="footer-brand-name">منصة البارون</div>
          <p class="footer-desc">{{ data.footer_description || 'تصفح الآلاف من الكورسات حول العالم' }}</p>
        </div>
      </div>

      <nav class="footer-links">
        <b-link to="/aboutus">من نحن</b-link>
        <b-link to="/contactus">اتصل بنا</b-link>
      </nav>

      <div class="footer-actions">
        <div class="footer-social">
          <a v-for="s in socialLinks" :key="s.key" :href="s.href" :aria-label="s.label" :title="s.label"
            target="_blank" rel="noopener" class="social-btn">
            <img :src="s.icon" :alt="s.label">
          </a>
        </div>
        <div class="footer-stores">
          <a v-if="data.google_store" :href="data.google_store" target="_blank" rel="noopener">
            <img src="../../assets/images/googleplaybtn.png" alt="تطبيق منصة البارون - جوجل بلاي">
          </a>
          <a v-if="data.apple_store" :href="data.apple_store" target="_blank" rel="noopener">
            <img src="../../assets/images/applestorebtn.png" alt="تطبيق منصة البارون - ابل ستور">
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <span>جميع الحقوق محفوظة © {{ new Date().getFullYear() }} منصة البارون</span>
      <span class="footer-version">الإصدار {{ version }}</span>
    </div>
  </footer>
</template>

<script>
import { sendRequest } from "../../utils/RequestHelper.js"

const SOCIALS = [
  { key: "meta", label: "فيسبوك", icon: require("../../assets/images/faceg.png") },
  { key: "twitter", label: "إكس", icon: require("../../assets/images/twitterx.png") },
  { key: "youtube", label: "يوتيوب", icon: require("../../assets/images/ytg.png") },
  { key: "instagram", label: "إنستغرام", icon: require("../../assets/images/instagram.png") },
  { key: "linkedin", label: "لينكد إن", icon: require("../../assets/images/linkedg.png") },
  { key: "googel", label: "جوجل", icon: require("../../assets/images/googleg.png") },
  { key: "snapchat", label: "سناب شات", icon: require("../../assets/images/snapchat.png") },
  { key: "tiktok", label: "تيك توك", icon: require("../../assets/images/tiktokg.png") },
];

export default {
  data() {
    return {
      data: {},
      version: process.env.VUE_APP_VERSION
    };
  },
  computed: {
    socialLinks() {
      return SOCIALS.filter(s => this.data[s.key]).map(s => ({ ...s, href: this.data[s.key] }));
    }
  },
  methods: {
    loadData() {
      sendRequest('get', 'configuration/configuration/', false, {}, (data) => {
        this.data = data || {}
      }, () => {});
    },
  },
  created() {
    this.loadData()
  }
};
</script>

<style scoped>
.site-footer {
  /* pages rendered with App.vue's floated .pageContent must not flow under the footer */
  clear: both;
  background: linear-gradient(135deg, var(--brand-teal-dark), var(--brand-teal));
  color: #fff;
  text-align: right;
}

.footer-main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 32px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 320px;
  min-width: 0;
}

.footer-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  background: #fff;
  border-radius: 12px;
  padding: 5px;
  flex-shrink: 0;
}

.footer-brand-name {
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.3;
}

.footer-desc {
  margin: 0;
  font-size: 0.85rem;
  opacity: 0.8;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.footer-links {
  display: flex;
  gap: 20px;
}

.footer-links a {
  color: #fff;
  font-size: 0.95rem;
  opacity: 0.85;
  text-decoration: none;
  transition: opacity 0.2s, color 0.2s;
}

.footer-links a:hover {
  opacity: 1;
  color: var(--brand-teal-light);
}

.footer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
}

.footer-social {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.social-btn {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  transition: background 0.2s, transform 0.2s;
}

.social-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.social-btn img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.footer-stores {
  display: flex;
  gap: 8px;
}

.footer-stores img {
  height: 36px;
  width: auto;
  display: block;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 16px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 0.8rem;
  opacity: 0.75;
}

.whatsapp-float {
  position: fixed;
  bottom: 50px;
  left: 50px;
  z-index: 5000;
}

.whatsapp-float img {
  width: 50px;
  display: block;
}

@media (max-width: 768px) {
  .footer-main,
  .footer-bottom {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }

  .footer-brand {
    flex-direction: column;
    flex-basis: auto;
  }

  .footer-actions {
    justify-content: center;
  }

  .whatsapp-float {
    bottom: 20px;
    left: 20px;
  }
}
</style>
